import React from 'react';
import { ReactComponent as NewUpdatesImg } from 'Assets/svg/updates-img.svg';
import { ReactComponent as RoleChangesImg } from 'Assets/svg/role-changes-img.svg';
import { ReactComponent as OtherUpdatesImg } from 'Assets/svg/other-updates-img.svg';
import { ReactComponent as NewClockIcon } from 'Assets/svg/clock-icon.svg';
import { ReactComponent as CrossIcon } from 'Assets/usageAnalytics/cross-icon.svg';

const DropDownForRoleAndUpdates = ({
  selectedValue = '',
  updatedFlag,
  currentTab = 0,
  handleOnClickDays = null,
  closeHoverPopUp,
}) => {
  return (
    <div onClick={e => e.stopPropagation()}>
      <span
        className={updatedFlag ? 'top-sharp-point' : 'role-changes-sharp-point'}
      />
      <div>
        <div className={`new-updates-img ${updatedFlag ? '' : 'updates-img'}`}>
          {updatedFlag ? (
            <NewUpdatesImg className="available-updates" />
          ) : (
            <>
              {currentTab === 2 && <RoleChangesImg className="role-changes" />}
              {currentTab === 3 && (
                <OtherUpdatesImg className="other-updates" />
              )}
            </>
          )}
          <CrossIcon className="cross-icon" onClick={closeHoverPopUp} />
        </div>
        {updatedFlag ? (
          <>
            <h4>Refresh your Data!</h4>
            <span>
              We have new updates for the
              <br /> contacts purchased by you.
              <br /> Don&apos;t forget to check it out.
            </span>
          </>
        ) : (
          <>
            {currentTab === 2 && (
              <span>
                Some of your contacts have changed
                <br /> their roles. Check it out!
              </span>
            )}
            {currentTab === 3 && (
              <span>
                Check out the other updated <br />
                information of your contacts here.
              </span>
            )}
            <div className="role-changes-container">
              {currentTab === 2 && <p>Role changes in</p>}
              {currentTab === 3 && <p>Other updates in</p>}
              <div
                className={`role-changes-days${
                  selectedValue === '90D' ? ' selected' : ''
                }`}
                onClick={() => handleOnClickDays('90D')}
              >
                <NewClockIcon />
                Last 90 Days
              </div>
              <div
                className={`role-changes-days${
                  selectedValue === '60D' ? ' selected' : ''
                }`}
                onClick={() => handleOnClickDays('60D')}
              >
                <NewClockIcon />
                Last 60 Days
              </div>
              <div
                className={`role-changes-days${
                  selectedValue === '30D' ? ' selected' : ''
                }`}
                onClick={() => handleOnClickDays('30D')}
              >
                <NewClockIcon />
                Last 30 Days
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DropDownForRoleAndUpdates;
